

function LiItemWeb({ text, link }) {
    return (
        <li className="mx-7 text-slate-700 text-sm
                        hover:text-blue-800
                        hover:cursor-pointer 
                        hover:font-bold "
        >
            <a href={link}>
                {text}
            </a>
        </li >
    )
}
export default LiItemWeb;